import { Divider, VStack } from '@chakra-ui/react';
import Markdown from '@/components/atoms/Markdown/Markdown';
import AuthorHeader from '@/modules/content/feed/reader/parts/AuthorHeader';
import TitleBlock from '@/modules/content/feed/reader/parts/TitleBlock';
import { TReaderDetails } from '@/modules/content/feed/reader/model/articleStructure';
import { readerCardProps } from '@/modules/content/feed/reader/model/readerStyles';
import { TContent } from '@/types/Content.types';

const PostBody = ({ content, details }: { content: TContent; details: TReaderDetails }) => (
  <VStack {...readerCardProps} align="stretch" gap="22px">
    <AuthorHeader content={content} />
    <TitleBlock content={content} />
    <Divider />
    <Markdown>{details.body || '_No content._'}</Markdown>
  </VStack>
);

export default PostBody;
